import { render, staticRenderFns } from "./breed-form-select.vue?vue&type=template&id=0381285d&"
import script from "./breed-form-select.vue?vue&type=script&lang=js&"
export * from "./breed-form-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "breed-form-select.vue"
export default component.exports